'use es6';

import { combineReducers } from 'redux';
import activeCurrencyCode from 'pricing-pages-unified-ui/reducers/ActiveCurrencyCode';
import activeHub from 'pricing-pages-unified-ui/reducers/ActiveHub';
import auth from 'pricing-pages-unified-ui/reducers/Auth';
import config from 'pricing-pages-unified-ui/reducers/Config';
import country from 'pricing-pages-unified-ui/reducers/Country';
import customerCurrencyCode from 'pricing-pages-unified-ui/reducers/CustomerCurrencyCode';
import numContactsInCrm from 'pricing-pages-unified-ui/reducers/NumContactsInCrm';
import purchaseMotionsByLocation from 'pricing-pages-unified-ui/reducers/PurchaseMotionsByLocation';
import requiredOnboarding from 'pricing-pages-unified-ui/reducers/RequiredOnboarding';
import settings from 'pricing-pages-unified-ui/reducers/Settings';
import iris from 'pricing-pages-unified-ui/reducers/Iris';
import promotions from 'pricing-pages-unified-ui/reducers/Promotions';
import phoneNumbers from 'pricing-pages-unified-ui/reducers/PhoneNumbers';
import experimentTreatments from 'pricing-pages-unified-ui/reducers/ExperimentTreatments';
import publicFeatureFlags from 'pricing-pages-unified-ui/reducers/PublicFeatureFlags';
import queryParamTerm from 'pricing-pages-unified-ui/reducers/QueryParamTerm';
import marketingContacts from 'pricing-pages-unified-ui/reducers/MarketingContacts';
import hsfs from 'pricing-pages-unified-ui/reducers/hsfs';
import abstractedProducts from './AbstractedProducts';
import retail from './Retail';
import features from './Features';
import businessObjectives from './BusinessObjectives';
import requests from 'pricing-pages-unified-ui/reducers/Requests';
import productInventory from 'pricing-pages-unified-ui/reducers/ProductInventory';
import tbPilotStatus from 'pricing-pages-unified-ui/reducers/TBPilotStatus';
export default combineReducers({
  abstractedProducts,
  activeCurrencyCode,
  activeHub,
  auth,
  config,
  country,
  customerCurrencyCode,
  experimentTreatments,
  hsfs,
  iris,
  marketingContacts,
  numContactsInCrm,
  phoneNumbers,
  publicFeatureFlags,
  purchaseMotionsByLocation,
  promotions,
  productInventory,
  queryParamTerm,
  requests,
  requiredOnboarding,
  retail,
  settings,
  features,
  businessObjectives,
  tbPilotStatus
});